import React, { useState, useEffect } from 'react';

import useWindowDimensions from '@hooks/useWindowDimensions.js'
import Lightbox from 'yet-another-react-lightbox'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import 'yet-another-react-lightbox/styles.css'
import { splitLastOccurrence } from '@utils/utils.js'

import AngleLeft from '@components/Icons/AngleLeft.jsx';
import AngleRight from '@components/Icons/AngleRight.jsx';

const ProductImagesNosto = ({
	currentImages,
	currentProductTags,
	currentProduct,
}) => {
    // console.log('currentImages', currentImages)
    // state for lightbox
    const { windowWidth } = useWindowDimensions()
    const [open, setOpen] = useState(false)
    const [slideIndex, setSlideIndex] = useState(0)
    const [slides, setSlides] = useState()

    const lightboxOptions = {
        plugins: [Zoom]
    }

    const handleLightbox = (index) => {
        if (windowWidth && windowWidth < 768) {
            return
        }
        setOpen(true)
        setSlideIndex(index)
    }

    const handleImageNavigation = (e, direction, index) => {
        const imageArrayLength = currentImages.length
        const element = document.getElementById('image-grid')
        const positionInfo = element.getBoundingClientRect()
        const width = positionInfo.width
        const tileWidth = width / imageArrayLength
        let currentIndex = index

        let newPosition

        if (direction === 'right') {
            if (currentIndex === imageArrayLength - 1) {
                currentIndex = 0
                newPosition = 0 // Reset to the initial position
            } else {
                currentIndex++
                newPosition = -tileWidth * currentIndex
            }

            element.style.transform = `translateX(${newPosition}px)`
        }

        if (direction === 'left') {
            if (currentIndex === 0) {
                currentIndex = imageArrayLength - 1
            } else {
                currentIndex--
            }

            newPosition = -tileWidth * currentIndex
            element.style.transform = `translateX(${newPosition}px)`
        }
    }


	// get the total value of the product bundle based on set tags
	let valueCostTag = null;

	const valueCost = currentProductTags?.find((tag) => tag.includes('value'));

	if (valueCost && valueCost.startsWith('value')) {
		// expects tags to follow format: value100
		const totalCost = parseInt(valueCost.substring(5), 10);
		const formattedValueCost = `$${totalCost} value`;
		valueCostTag = formattedValueCost;
	}

	// get the number of items from the product tags
	let numberOfItemsTag = null;

	const numberOfItems = currentProductTags?.find((tag) =>
		tag.includes('items')
	);

	if (numberOfItems) {
		const match = numberOfItems.match(/(\d+)items/);
		const totalItems = parseInt(match[1], 10);
		const formattedNumberOfItems = `${totalItems} items`;
		numberOfItemsTag = formattedNumberOfItems;
	}

    useEffect(() => {
        // create slides for lightbox
		if (currentImages && currentImages.length > 0) {
			let imagesAsSlides = currentImages.map((m, i) => {
				const [srcBefore, srcAfter] = splitLastOccurrence(
					m,
					'.'
				);
				let imageSrc = srcBefore;
				// Replace only the last occurrence of _1200x1800 before the extension
				imageSrc = imageSrc.replace(
					/_1200x1800([^_.]*)$/,
					'_2400x3600'
				);
				imageSrc = imageSrc + '.' + srcAfter;

				return {
					src: imageSrc,
					alt: m.imageAlt ? m.imageAlt : '',
				};
			});

			setSlides(imagesAsSlides);
		}
	}, [currentImages]);

	return (
		<div className='product-images-outer w-full lg:w-5/12 relative'>
			{valueCostTag && (
				<div className='mt-2 px-1 lg:px-2 py-0 border border-slate font-light lg:text-xs inline-flex items-center flex-0 bg-white text-flint justify-center text-center z-[2] absolute top-0 -left-[1px]'>
					<span className='uppercase font-semibold'>
						{valueCostTag}
					</span>
				</div>
			)}
			{numberOfItemsTag && (
				<div className='mt-2 px-1 lg:px-2 py-0 border border-slate font-light lg:text-xs inline-flex items-center flex-0 bg-white text-flint justify-center text-center z-[2] absolute top-0 -left-[1px]'>
					<span className='uppercase font-semibold'>
						{numberOfItemsTag}
					</span>
				</div>
			)}
			<div className='product-images-inner flex gap-4 overflow-x-auto'>
				<div className='image-grid relative flex items-center'>
					<ul
						id='image-grid'
						className='images-nav nostyle md:grid md:grid-cols-2 gap-2 flex items-center overflow-x-scroll md:overflow-x-hidden relative'
					>
						{currentImages && currentImages.length > 0 ?
							currentImages.map((currentImage, index) => {
								return (
									<li
										key={`${currentImage}-${index}`}
										data-index={index}
										data-color={currentImage.initial_color}
										className={`nav-image relative w-[95vw] lg:w-full ${
											index === 0
												? 'md:w-full md:col-span-2'
												: 'md:width-unset'
										}`}
										title={currentImage.initial_color}
										style={{
											aspectRatio: '2/3',
											minHeight: '400px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}
									>
										{index !== 0 ? (
											<div
												className='caret-left md:hidden absolute left-3 text-flint cursor-pointer'
												onClick={(e) =>
													handleImageNavigation(
														e,
														'left',
														index
													)
												}
											>
												<AngleLeft width='w-[12px]' />
											</div>
										) : null}
										<img
											className={`md:cursor-pointer w-full h-full ${
												currentProduct?.brand && currentProduct.brand !== 'Monica + Andy'
													? 'bg-white object-cover'
													: 'bg-[#f8f8f8] object-contain'
											}`}
											src={currentImage}
											alt={currentImage.initial_color}
											onClick={() =>
												handleLightbox(index)
											}
											fetchPriority='high'
											style={{
												objectFit: currentProduct?.brand && currentProduct.brand !== 'Monica + Andy' ? 'cover' : 'contain',
												objectPosition: 'center'
											}}
										/>
										{index < currentImages.length - 1 ? (
											<div
												className='caret-right md:hidden right-[21px] absolute text-flint cursor-pointer'
												onClick={(e) =>
													handleImageNavigation(
														e,
														'right',
														index
													)
												}
											>
												<AngleRight width='w-[12px]' />
											</div>
										) : null}
									</li>
								);
							})
						: (
							<li className={`nav-image flex items-center justify-center h-[400px] w-[95vw] lg:w-full ${
								currentProduct?.brand && currentProduct.brand !== 'Monica + Andy'
									? 'bg-white'
									: 'bg-[#f8f8f8]'
							}`}>
								<span className="text-gray-400 sr-only">No image available</span>
							</li>
						)}
					</ul>
				</div>
			</div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={slideIndex}
                slides={slides}
                plugins={[Zoom]}
                zoom={{
                    maxZoomPixelRatio: 5
                }}
            />
		</div>
	);
}

export default ProductImagesNosto
